import { PropsWithChildren, useState } from "react";
import { Outlet } from "react-router";

import { useLaunchParams } from "@tma.js/sdk-react";

import desktopGuardBg from "shared/assets/desktop-guard-bg.png";
import WomanWithGalactica from "shared/assets/woman-with-galactica.svg?react";

export const DesktopGuard = ({ children }: PropsWithChildren) => {
  const { tgWebAppPlatform } = useLaunchParams();
  const [count, setCount] = useState(0);

  if (
    tgWebAppPlatform !== "ios" &&
    tgWebAppPlatform !== "android" &&
    !import.meta.env.DEV &&
    count < 10
  )
    return (
      <div
        style={{
          backgroundImage: `url(${desktopGuardBg})`,
          objectFit: "contain",
        }}
        className="mx-auto flex h-full max-w-md grow flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
      >
        <WomanWithGalactica
          className="grayscale-100"
          onClick={() => {
            setCount(count + 1);
          }}
        />
        <h1 className="mt-5 text-center text-2xl leading-[120%] font-semibold whitespace-pre-line">
          {"Galactica Telegram\nPassport is available only\non mobiles"}
        </h1>
        <div className="text-balticSea/50 mt-2 flex gap-x-3 px-3.5 py-2.5">
          <p className="line-clamp-2 text-sm leading-[160%]">
            Please, switch your device and come back
          </p>
        </div>
      </div>
    );

  return children ?? <Outlet />;
};
